/** eslint-disable-next-line */
import {
  calcNum,
  getFullWidth,
  getPixelRatio,
  isIOS,
  isIPhoneX,
  isAndroid,
  transformSize,
  getFullHeight,
  getWindowHeight,
  statusBarHeight,
  getStatusBarHeight,
  create,
} from './StyleSheet';

export default {
  install(Vue) {
    Vue.prototype.createStyle = style => create({ style }).style;
    Vue.prototype.calcNum = calcNum;
    Vue.prototype.getPixelRatio = getPixelRatio;
    Vue.prototype.getFullWidth = getFullWidth;
    Vue.prototype.isIPhoneX = isIPhoneX;
    Vue.prototype.isIOS = isIOS;
    Vue.prototype.isAndroid = isAndroid;
    Vue.prototype.transformSize = transformSize;
    Vue.prototype.getFullHeight = getFullHeight;
    Vue.prototype.getWindowHeight = getWindowHeight;
    Vue.prototype.statusBarHeight = statusBarHeight;
    Vue.prototype.getStatusBarHeight = getStatusBarHeight;
  },
};
